<template>
  <div class="ag-header-group-cell-label">
    <div class="customHeaderLabel">
      <span class="sr-only">{{ params.srLabel }}</span
      >{{ params.displayName }}
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'option-chain-header-renderer'
});
</script>

<style lang="scss" scoped></style>
